import { Component, OnInit } from "@angular/core";
// import { MobileNotSupportedComponent } from "../mobile-not-supported/mobile-not-supported.component";
import { HeaderComponent } from "../header/header.component";
import { provideNativeDateAdapter } from "@angular/material/core";
import { AsyncPipe, DatePipe, NgClass } from "@angular/common";
import { Router, NavigationEnd, RouterLink, RouterOutlet } from "@angular/router";
import { filter, Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { selectUnreadCount } from "src/app/store/counter.selectors";
import { setUnreadCount } from "src/app/store/counter.actions";
import { ChatService } from "src/app/service/chat.service";

@Component({
  selector: "app-lead-track",
  providers: [provideNativeDateAdapter()],
  imports: [
    HeaderComponent,
    // MobileNotSupportedComponent,
    DatePipe,
    AsyncPipe,
    NgClass,
    RouterOutlet,
    RouterLink
  ],
  templateUrl: "./lead-track.component.html",
  styleUrl: "./lead-track.component.css"
})
export class LeadTrackComponent implements OnInit {

  radialChartData: any[] = [];
  unreadCount$: Observable<number>;
  isMobileNavOpen = false;

  toggleMobileNav() {
    this.isMobileNavOpen = !this.isMobileNavOpen;
  }

  constructor(
    private router: Router,
    private store: Store,
    public chatService: ChatService
  ) { }

  get isDarkTheme(): boolean {
    return document.body.classList.contains('dark-theme');
  }

  getIconFilter(itemId: string): string {
    if (this.activeMenu === itemId) {
      return this.isDarkTheme ? 'brightness(1)' : 'brightness(0)';
    }
    return 'brightness(1)';
  }

  userDepartment: any;
  calendarView: any;
  ngOnInit() {
    this.setActiveMenuFromRoute();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setActiveMenuFromRoute();
        this.isMobileNavOpen = false;
      });

    this.chatService.toggleLeadTrackMenu$.subscribe(() => {
      this.toggleMobileNav();
    });



    this.userDepartment = localStorage.getItem("department") || "";
    this.calendarView = this.userDepartment === "SALES" || this.userDepartment === "ASSISTANT-SALES" || this.userDepartment === "MARKETING";

    if (!this.chatService.isConnected) {
      this.chatService.initChatConnection();
    }
    this.chatService.connectSocket();
    this.unreadCount$ = this.store.select(selectUnreadCount);

    this.getInitialUnreadCount();
  }

  getInitialUnreadCount() {
    const userId = localStorage.getItem("guestID");
    this.chatService.getChats().subscribe({
      next: (resp: any) => {
        const users = resp.data || [];
        let totalUnreadCount = 0;

        users.forEach((user: any) => {
          // Server count is authoritative so reads on other devices are reflected
          let unreadCount = user.unreadCount || 0;

          if (user.type === "group") {
            let isExited = user.isExited;
            if (user.members) {
              const me = user.members.find((m: any) => String(m.userId) === String(userId));
              if (me && (me.leftGroup || me.isRemoved)) {
                isExited = true;
              }
            }
            if (isExited) unreadCount = 0;
          }

          if (unreadCount > 0) totalUnreadCount += unreadCount;
        });

        this.store.dispatch(setUnreadCount({ unreadCount: totalUnreadCount }));
      },
      error: (err) => {
        console.error("Failed to fetch initial unread count:", err);
      }
    });
  }

  setActiveMenuFromRoute() {
    const currentRoute = this.router.url;

    if (currentRoute.includes('/lead-track/calendar-view')) {
      this.activeMenu = 'calendar';
      return;
    }

    if (currentRoute === '/home') {
      this.activeMenu = '';
      return;
    }

    const activeItem = this.menuItems.find(item =>
      currentRoute.includes(item.route)
    );

    if (activeItem) {
      this.activeMenu = activeItem.id;
    }
  }

  shareLeadModalInstance: any;
  iicContactUsleadDetail: any;
  ngAfterViewInit(): void { }

  projectIcons: { [key: string]: string } = {
    "V-RETAIL": "../../assets/vretail-icon-9.png",
    "V-ESTATE": "../../assets/vestate-icon.png",
    "IIC-LAB": "../../assets/iic-leads-icon.png",
    "OUTBOUND": "../../assets/leads/default-icon.png",
  };

  projectTabsMap: { [key: string]: string[] } = {
    "ALL": ["ALL", "Contact Us", "Newsletter", "Career", "IVR", "Book Demo", "User Onboard", "Lead Magnet Features", "Lead Magnet Book Demo", "Lead Magnet Pricing", "Whatsapp", "Email", "Ads"],
    "IIC-LAB": ["Contact Us", "Newsletter", "Career", "IVR", "Whatsapp", "Email", "Ads"],
    "V-RETAIL": [
      "Book Demo",
      "Contact Us",
      "User Onboard",
      "Lead Magnet Features",
      "Lead Magnet Book Demo",
      "Lead Magnet Pricing",
      "Email",
      "Ads"
    ],
    "V-ESTATE": ["Book Demo", "Contact Us", "Whatsapp", "Email", "Ads"],
    "OUTBOUND": ["Contact Us", "Manual", "IVR", "Whatsapp", "Ads"],
  };

  menuItems = [
    {
      id: 'all',
      label: 'ALL LEADS',
      icon: '../../assets/leads/all-projects-white.png',
      activeIcon: '../../assets/leads/all-projects-icon.png',
      route: '/lead-track/all-leads'
    },
    {
      id: "iic",
      label: "IIC",
      icon: "../../assets/leads/iic-white.png",
      activeIcon: "../../assets/iic-leads-icon.png",
      route: "/lead-track/iic-leads"
    },
    {
      id: "vretail",
      label: "V-RETAIL",
      icon: "../../assets/leads/vretail-white.png",
      activeIcon: "../../assets/vretail-icon-9.png",
      route: "/lead-track/vretail-leads"
    },
    {
      id: "vestate",
      label: "V-ESTATE",
      icon: "../../assets/leads/vestate-white.png",
      activeIcon: "../../assets/vestate-icon.png",
      route: "/lead-track/vestate-leads"
    },
    {
      id: "outbound",
      label: "OUTBOUND",
      materialIcon: "outbound",
      icon: "../../assets/leads/default-icon.png",
      activeIcon: "../../assets/leads/default-icon.png",
      route: "/lead-track/outbound-leads"
    },
    {
      id: 'calendar',
      label: 'CALENDAR',
      icon: '../../assets/leads/calendar-white.png',
      activeIcon: '../../../assets/leads/calendar.png',
      route: '/lead-track/calendar-view',
      showWhenCalendarViewIsFalse: true
    },
    {
      id: 'chat',
      label: 'CHAT',
      materialIcon: 'chat_bubble',
      iconClass: 'material-symbols-outlined',
      icon: '../../assets/leads/chat-icon.png',
      route: '/main-chat'
    }
  ];

  activeMenu = "all";
  navigateTo(menu: any) {
    this.activeMenu = menu.id;
    this.isMobileNavOpen = false;
    this.router.navigate([menu.route], { queryParams: {} });
  }

  navigateToCalendar() {
    this.activeMenu = 'calendar';
    this.isMobileNavOpen = false;
    this.router.navigate(['/lead-track/calendar-view']);
  }


}
